import { ReactNode, createContext, useContext, useMemo } from 'react';
import { Brand, getBrandConfig, detectBrand } from 'utils/global/branding';

type BrandContextType = {
  brand: Brand;
  brandConfig: ReturnType<typeof getBrandConfig>;
  isOffitel: boolean;
  isMemo: boolean;
};

const BrandContext = createContext<BrandContextType | null>(null);

export default function BrandContextProvider({ children }: { children: ReactNode }) {
  const brand = useMemo(() => {
    return detectBrand();
  }, []);
  const brandConfig = useMemo(() => {
    return getBrandConfig();
  }, []);

  const value = useMemo(() => {
    return {
      brand,
      brandConfig,
      isOffitel: brand === 'offitel',
      isMemo: brand === 'memo',
    };
  }, [brand, brandConfig]);

  return <BrandContext.Provider value={value}>{children}</BrandContext.Provider>;
}

export function useBrand() {
  const context = useContext(BrandContext);

  if (context === null) {
    throw new Error('useBrand must be used within a BrandContextProvider');
  }

  return context;
}
